import { render, staticRenderFns } from "./dailog-new-version-notification-settings.vue?vue&type=template&id=70333a53&scoped=true"
import script from "./dailog-new-version-notification-settings.vue?vue&type=script&lang=js"
export * from "./dailog-new-version-notification-settings.vue?vue&type=script&lang=js"
import style0 from "./dailog-new-version-notification-settings.vue?vue&type=style&index=0&id=70333a53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70333a53",
  null
  
)

export default component.exports